export default [
  {
    name : "Consultas",
    route: "Consultas",
    image : "/assets/images/menu-item-2.png",
    alt : "",
    link: "/home-cliente"
  },
  {
    name : "Sair",
    image : "/assets/images/menu-item-5.png",
    alt : "",
    link: "/dash/logout"
  }
]
